import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";
import DateAdapter from "../../adapters/DateAdapter";

export default class CustomerOnboardingsResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: [
                {
                    'request':
                        {
                            'taxpayer_identification_number': '123456789',
                            'requester': 'lcuadrado@eryx.co',
                            'request_timestamp': '25-25-25 25:25:25',
                            'legal_entity': {
                                'business_name': 'Razón Social S.A.'
                            }
                        },
                    'state': 'PENDING',
                    'close_datetime': '25-25-25 25:25:25',
                    'logistics_authorization': true,
                    'commercial_authorization': true,
                    'finance_authorization': false,
                    'tax_authorization': false,
                }
            ],
            errors: [],
        }
    }

    customerOnboardings() {
        return this.content().map(customerOnboarding => {
            return {
                'request':
                    {
                        'taxpayerIdentificationNumber': customerOnboarding.request.taxpayer_identification_number,
                        'businessName': customerOnboarding.request.legal_entity.business_name,
                        'requester': customerOnboarding.request.requester,
                        'requestTimestamp': this._adaptDatetime(customerOnboarding.request.request_timestamp)
                    },
                'state': this._adaptState(customerOnboarding.state),
                'closeDatetime': this._adaptDatetime(customerOnboarding.close_datetime),
                'logisticsAuthorization': customerOnboarding.logistics_authorization,
                'commercialAuthorization': customerOnboarding.commercial_authorization,
                'financeAuthorization': customerOnboarding.finance_authorization,
                'taxAuthorization': customerOnboarding.tax_authorization,
            }
        })
    }

    _adaptDatetime(datetime) {
        if (datetime === null) {
            return '-';
        } else {
            return DateAdapter.adaptDatetime(datetime)
        }
    }

    _adaptState(value) {
        if (value === "PENDING") {
            return 'Pendiente';
        }
        if (value === 'PROCESSING_BY_AREA_STATE'){
            return 'Procesando por Áreas'
        }
        if (value === 'PENDING_ERP_LOAD') {
            return 'Pendiente de carga en el ERP';
        }
        if (value === 'CLOSED') {
            return 'Cerrado';
        }
    }
}
